import { enableProdMode, importProvidersFrom } from "@angular/core";

import { CommonModule } from "@angular/common";
import { provideHttpClient } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBarModule } from "@angular/material/snack-bar";
import { bootstrapApplication } from "@angular/platform-browser";
import { provideAnimations } from "@angular/platform-browser/animations";
import { RouterModule, provideRouter } from "@angular/router";
import { NgxMaskApplierService } from "ngx-mask";
import { ToastrModule } from "ngx-toastr";
import { AppComponent } from "./app/app.component";
import { routes } from "./app/app.routes";
import { environment } from "./environments/environment";

if (environment.production) {
  enableProdMode();
}

// Bootstrapping App as a Standalone Component (eliminates all NgModules)
bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes), // app.routes.ts
    provideAnimations(), // BrowserAnimationsModule
    provideHttpClient(), // Angular v15 method of injecting HttpClient
    importProvidersFrom([
      CommonModule,
      ReactiveFormsModule,
      FormsModule,
      MatCardModule,
      MatInputModule,
      MatButtonModule,
      MatDialogModule,
      MatFormFieldModule,
      MatIconModule,
      MatCardModule,
      MatExpansionModule,
      MatSlideToggleModule,
      MatExpansionModule,
      MatDividerModule,
      MatSnackBarModule,
      RouterModule,
      ToastrModule,
      NgxMaskApplierService,
    ]),
    { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 5000 } },
  ],
}).catch((err) => console.error(err));

// entryComponents: [SubmitDialogComponent],
// imports: [BrowserModule, ToastrModule.forRoot(), HttpClientModule, FormsModule, ReactiveFormsModule, AppRoutingModule, BrowserAnimationsModule, MaterialModule, NgxMaskDirective],
// providers: [, ],
